import { z } from 'zod';

export const CACHE_MANAGER_KEY = {
    ALL_SPORTS_KEY: 'all-sports-cache',
    ALL_ACTIVE_SPORTS_KEY: 'all-active-sports-cache',
    TOP_HEADER_NAVIGATION: 'top-header-navigation-cache',
} as const;

export type CacheManagerKeyType = (typeof CACHE_MANAGER_KEY)[keyof typeof CACHE_MANAGER_KEY];

export const TIMERS_CLEAR_CACHE = {
    LONG_TIMERS: 5 * 60 * 1000, // 5 min
    SHORT_TIMERS: 1 * 60 * 1000, // 1 min
} as const;

export const CacheManagerHydrationDataZOD = z.object({
    [CACHE_MANAGER_KEY.ALL_ACTIVE_SPORTS_KEY]: z
        .array(z.object({ key: z.string(), doc_count: z.number() }))
        .optional()
        .nullable(),
});

export type CacheManagerHydrationDataType = z.infer<typeof CacheManagerHydrationDataZOD>;
